// This is just an array of the app's defined paths that can be used in our Cloudflare Functions.
// Do not add any imports to this file.
// The array is kept up to date via the tests in src/pages/paths.test.ts

export const paths = [
  '/',
  '/explore',
  '/explore',
  '/explore/tokens/:chainName/:tokenAddress',
  '/tokens',
  '/tokens/:chainName',
  '/tokens/:chainName/:tokenAddress',
  '/explore/pools/:chainName/:poolAddress',
  '/explore/auctions/:chainName/:auctionAddress',
  '/vote/*',
  '/create-proposal',
  '/sell',
  '/send',
  '/swap',
  '/buy',
  '/limit',
  '/limits',
  '/buy',
  '/pool/v2/find',
  '/pool/v2',
  '/pool/new',
  '/pool',
  '/pool/:tokenId',
  '/pools/v2/find',
  '/pools/v2',
  '/pools/new',
  '/pools',
  '/pools/:tokenId',
  '/liquidity/launch-auction',
  '/portfolio',
  '/portfolio/tokens',
  '/portfolio/defi',
  '/portfolio/nfts',
  '/portfolio/activity',
  '/portfolio/:walletAddress',
  '/portfolio/:walletAddress/tokens',
  '/portfolio/:walletAddress/defi',
  '/portfolio/:walletAddress/nfts',
  '/portfolio/:walletAddress/activity',
  '/positions',
  '/positions/create',
  '/positions/create/:protocolVersion',
  '/positions/v2/:chainName/:pairAddress',
  '/positions/v3/:chainName/:tokenId',
  '/positions/v4/:chainName/:tokenId',
  '/add/v2',
  '/add',
  '/increase',
  '/remove/v2/:currencyIdA/:currencyIdB',
  '/remove/:tokenId',
  '/migrate/v2/:chainName/:pairAddress',
  '/migrate/v3/:chainName/:tokenId',
  '/portfolio',
  '/portfolio/tokens',
  '/portfolio/defi',
  '/portfolio/nfts',
  '/portfolio/activity',
  '/auth/passkey/extension',
  '/manage/passkey/:walletAddress',
  '/extension/uninstall',
  '/wrapped',
]
